'use client';

import { createContext, FC, ReactNode, useContext } from 'react';

const MessageGroupsContext = createContext<string[] | undefined>(undefined);

type Props = {
    messageGroups: string[];
    children: ReactNode;
};

export const MessageGroupsProvider: FC<Props> = ({ messageGroups, children }) => (
    <MessageGroupsContext.Provider value={messageGroups}>{children}</MessageGroupsContext.Provider>
);

export const useMessageGroupsFromContext = (): string[] | undefined => useContext(MessageGroupsContext);
